export const SHAPE_KINDS = {
  RECT: 'rect',
  ELLIPSE: 'ellipse',
  LINE: 'line',
  ARROW: 'arrow',
  FADE: 'fade',
};

export const ARROW_HEAD_RATIO = 3.2;

const shortSideOf = (doc) => Math.min(doc.width, doc.height);

export const SHAPE_GROUPS = [
  {
    id: 'basic',
    labelKey: 'shapeGroupBasic',
    presets: [
      {
        id: 'rect',
        nameKey: 'shapeRect',
        build: (doc) => {
          const side = shortSideOf(doc);
          return {
            kind: SHAPE_KINDS.RECT,
            x: doc.width / 2,
            y: doc.height / 2,
            width: side * 0.4,
            height: side * 0.25,
          };
        },
      },
      {
        id: 'rounded',
        nameKey: 'shapeRounded',
        build: (doc) => {
          const side = shortSideOf(doc);
          return {
            kind: SHAPE_KINDS.RECT,
            x: doc.width / 2,
            y: doc.height / 2,
            width: side * 0.4,
            height: side * 0.25,
            cornerRadius: Math.round(side * 0.04),
          };
        },
      },
      {
        id: 'circle',
        nameKey: 'shapeCircle',
        build: (doc) => {
          const size = shortSideOf(doc) * 0.3;
          return {
            kind: SHAPE_KINDS.ELLIPSE,
            x: doc.width / 2,
            y: doc.height / 2,
            width: size,
            height: size,
            keepAspectRatio: true,
          };
        },
      },
      {
        id: 'line',
        nameKey: 'shapeLine',
        build: (doc) => {
          const side = shortSideOf(doc);
          return {
            kind: SHAPE_KINDS.LINE,
            x: doc.width / 2,
            y: doc.height / 2,
            width: side * 0.4,
            height: Math.max(2, Math.round(side * 0.008)),
            fill: '#ffffff',
          };
        },
      },
      {
        id: 'arrow',
        nameKey: 'shapeArrow',
        build: (doc) => {
          const side = shortSideOf(doc);
          return {
            kind: SHAPE_KINDS.ARROW,
            x: doc.width / 2,
            y: doc.height / 2,
            width: side * 0.3,
            height: Math.max(6, Math.round(side * 0.01)) * ARROW_HEAD_RATIO,
            fill: '#ffffff',
          };
        },
      },
    ],
  },
  {
    id: 'layout',
    labelKey: 'shapeGroupLayout',
    presets: [
      {
        id: 'overlay',
        nameKey: 'shapeOverlay',
        build: (doc) => ({
          kind: SHAPE_KINDS.RECT,
          x: doc.width / 2,
          y: doc.height / 2,
          width: doc.width,
          height: doc.height,
          fill: '#000000',
          opacity: 0.3,
        }),
      },
      {
        id: 'fadeBottom',
        nameKey: 'shapeFadeBottom',
        build: (doc) => ({
          kind: SHAPE_KINDS.FADE,
          direction: 'up',
          x: doc.width / 2,
          y: doc.height * 0.775,
          width: doc.width,
          height: doc.height * 0.45,
          fill: '#000000',
          opacity: 0.75,
        }),
      },
      {
        id: 'fadeTop',
        nameKey: 'shapeFadeTop',
        build: (doc) => ({
          kind: SHAPE_KINDS.FADE,
          direction: 'down',
          x: doc.width / 2,
          y: doc.height * 0.175,
          width: doc.width,
          height: doc.height * 0.35,
          fill: '#000000',
          opacity: 0.65,
        }),
      },
    ],
  },
];

export const DEFAULT_SHAPE = {
  kind: SHAPE_KINDS.RECT,
  fill: '#FDBF47',
  fillEnabled: true,
  stroke: '#111111',
  strokeEnabled: false,
  strokeWidth: 4,
  cornerRadius: 0,
  direction: 'up',
  blur: 0,
  shadow: { enabled: false, color: '#000000', blur: 12, offsetX: 0, offsetY: 6, opacity: 0.35 },
};

export const isLineShape = (element) => element?.kind === SHAPE_KINDS.LINE || element?.kind === SHAPE_KINDS.ARROW;
